
import { Splide, SplideSlide } from '@splidejs/react-splide';

import '@splidejs/react-splide/css';

import '@splidejs/react-splide/css/core';

function ProductSlider({firstImage,secondImage,thirdImage,Video}) {
    return (
     <div className='centered'>
    <Splide className="product-main-slider" options={ {
        rewind: true,
        gap: '1rem',
      } } aria-label="Slider">
        {firstImage && !firstImage.includes('null') && (
                    <SplideSlide>
                        <div className='product-main-slider'>
                            <img src={firstImage} alt="1" loading='lazy'/>
                        </div>
                    </SplideSlide>
                )}
               {secondImage && !secondImage.includes('null') && (
                    <SplideSlide>
                        <div className='product-main-slider'>
                            <img src={secondImage} alt="2" loading='lazy'/>
                        </div>
                    </SplideSlide>
                )}
                
                {thirdImage && !thirdImage.includes('null') && (
                    <SplideSlide>
                        <div className='product-main-slider'>
                            <img src={thirdImage} alt="3" loading='lazy'/>
                        </div>
                    </SplideSlide>
                )}
                
                {Video && !Video.includes('null') && (
                    <SplideSlide>
                        <div className='product-main-slider'>
                            <video loop muted autoPlay playsInline>
                                <source src={Video}/>
                                Ваш браузер не поддерживает видео.
                            </video>
                        </div>
                    </SplideSlide> )}
    </Splide>
     </div>
    );
}

export default ProductSlider;